import {Component, OnDestroy, OnInit} from '@angular/core';
import {Enterprise} from '../../../model/Enterprise';
import {Page} from '../../../../global/util/enum/Page';
import {Constant} from '../../../../global/util/Constant';
import {Partner} from '../../../model/Partner';
import {NgbCalendar, NgbDate, NgbDateParserFormatter, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from '../../../service/auth/auth.service';
import {Dialog} from '../../../../global/util/Dialog';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {InformType} from '../../../../global/util/enum/InformType';
import {Workflow} from '../../../model/Workflow';
import {SignatureReportService} from '../../../service/signature-report.service';
import {Router} from '@angular/router';
import {Service} from '../../../../global/util/Service';
import {GeneralQuantities} from '../../../model/GeneralQuantities';
import {NgbDateStructUtil} from '../../../../global/util/NgbDateStructUtil';
import {QueryLevel} from '../../../model/QueryLevel';
import {Consolidated} from '../../../model/Consolidated';
import {TranslateService} from '@ngx-translate/core';
import {Pagination} from '../../../../global/util/Pagination';

@Component({
  selector: 'app-consolidated-services-report',
  templateUrl: './consolidated-services-report.component.html',
  styleUrls: ['./consolidated-services-report.component.css']
})
export class ConsolidatedServicesReportComponent implements OnInit, OnDestroy {

  public title = 'TITLE.CONSOLIDATED-SERVICES';
  public consolidatedSignatures: Consolidated[] = [];
  public generalQuantities: GeneralQuantities[] = [];
  public enterprises: Enterprise[] = [];
  public page: any = {};
  public links: any = {};
  public enumPage = Page;
  public loading: boolean;
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public ROLE_ADMIN = Constant.ROLE_ADMIN;
  public partners: Partner[] = [];
  public workflowSelected: Workflow;
  public workflows: Workflow[] = [];
  public enterpriseSelected: Enterprise;
  public partnerSelected: Partner;
  public fromDate: NgbDate;
  public toDate: NgbDate;
  public ELECTRONIC_SIGNATURE = Service.ELECTRONIC;
  public DIGITAL_SIGNATURE = Service.DIGITAL;
  public CLOUD_SIGNATURE = Service.CLOUD;
  public REMOTE_SIGNATURE = Service.REMOTE;
  public REMOTE_SIGNATURE_WITH_TIMESTAMP = Service.REMOTE_WITH_TIMESTAMP;
  public REMOTE_SIGNATURE_WITH_LTV = Service.REMOTE_WITH_LTV;
  public TIMESTAMP = Service.TIMESTAMP;
  public SEND_ELECTRONIC_NOTIFICATION = Service.SEND_ELECTRONIC_NOTIFICATION;
  public SEND_EMAIL = Service.SEND_EMAIL;
  public NOTCER = Service.NOTCER;
  public queryLevel: number;
  private interval: any;
  public calledOfAutorefresh = false;
  public THREE_MONTHS_ON_DAYS = 91;
  public loadingShowBy = false;
  pageNumber: any;
  pageNumbers: any[] = [];

  constructor(private calendar: NgbCalendar,
              public formatter: NgbDateParserFormatter,
              private route: Router,
              public signatureReportService: SignatureReportService,
              private modalService: NgbModal,
              public authenticationService: AuthService,
              private translate: TranslateService) {
    const controls = LocalStorage.getSelectedControls();
    this.fromDate = controls ? controls.fromDate : calendar.getPrev(calendar.getToday(), 'd', this.THREE_MONTHS_ON_DAYS);
    this.toDate = controls ? controls.toDate : calendar.getToday();
    Dialog.createInstance(modalService);
    this.loadDefaultData(controls);
    this.getTotalByService();
  }

  ngOnInit(): void {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[Constant.ZERO_INDEX].value;
    this.beginAutorefreh();
  }

  ngOnDestroy(): void {
    this.destroyAutorefresh();
  }

  private destroyAutorefresh() {
    clearInterval(this.interval);
  }

  validatedDateTo = (date: NgbDate) => (date.before(this.fromDate) || date.after(this.calendar.getNext(this.fromDate, 'd', this.THREE_MONTHS_ON_DAYS))) || date.after(this.calendar.getToday());
  validatedDateFrom = (date: NgbDate) => (date.after(this.calendar.getToday()) || date.after(this.toDate));

  private loadDefaultData(controls: any) {
    this.partners = LocalStorage.getPartnersExtra();
    this.partnerSelected = controls ? this.partners.find(value => value.id === controls.partnerId) : this.partners[Constant.ZERO_INDEX];
    this.enterprises = LocalStorage.getEnterprisesExtraBy(this.partnerSelected.id);
    this.enterpriseSelected = controls ? this.enterprises.find(value => value.id === controls.enterpriseId) : this.enterprises[Constant.ZERO_INDEX];
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.workflows = controls ? LocalStorage.getWorkflowsExtraBy(this.enterpriseSelected.id) : LocalStorage.getWorkflowsExtraByPerson();
      this.workflowSelected = controls ? this.workflows.find(value => value.id === controls.workflowId) : this.workflows[Constant.ZERO_INDEX];
      this.queryLevel = controls ? controls.queryLevel : QueryLevel.LVL_ZERO;
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      const partnerId = LocalStorage.getPartnerId();
      this.enterprises = LocalStorage.getEnterprisesExtraBy(partnerId);
      this.enterpriseSelected = controls ? this.enterprises.find(value => value.id === controls.enterpriseId) : this.enterprises[Constant.ZERO_INDEX];
      this.workflows = LocalStorage.getWorkflowsExtraBy(this.enterpriseSelected.id);
      this.workflowSelected = controls ? this.workflows.find(value => value.id === controls.workflowId) : this.workflows[Constant.ZERO_INDEX];
      this.queryLevel = controls ? controls.queryLevel : QueryLevel.LVL_ONE;
    } else {
      const enterpriseId = LocalStorage.getEnterpriseId();
      this.workflows = LocalStorage.getWorkflowsExtraBy(enterpriseId);
      this.workflowSelected = controls ? this.workflows.find(value => value.id === controls.workflowId) : this.workflows[Constant.ZERO_INDEX];
      this.queryLevel = controls ? controls.queryLevel : QueryLevel.LVL_TWO;
    }
    this.search();
  }

  public loadConsolidatedServices(page: Page, callAutorefresh?: string): void {
    this.calledOfAutorefresh = !!callAutorefresh;
    let url;
    let partnerId;
    let enterpriseId;
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      partnerId = this.partnerSelected.id;
      enterpriseId = this.enterpriseSelected.id;
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      partnerId = LocalStorage.getPartnerId();
      enterpriseId = this.enterpriseSelected.id;
    } else {
      partnerId = LocalStorage.getPartnerId();
      enterpriseId = LocalStorage.getEnterpriseId();
    }
    switch (page) {
      case Page.First:
        url = Constant.ROOT_API_V1.concat('/consolidatedDetail/search?',
          'partnerId=', String(partnerId),
          '&enterpriseId=', String(enterpriseId),
          '&workflowId=', String(this.workflowSelected.id),
          '&dateFrom=', NgbDateStructUtil.toString2YYYYMMdd(this.fromDate),
          '&dateTo=', NgbDateStructUtil.toString2YYYYMMdd(this.toDate),
          '&size=' + this.pageNumber + '&sort=id,desc');
        break;
      case Page.Previous:
        url = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        url = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        url = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        url = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    this.getConsolidatedServices(url);
  }

  private getConsolidatedServices(url: string) {
    this.loading = true;
    this.signatureReportService.get(url).subscribe((next: any) => {
      this.loadingShowBy = this.loading = false;
      if (next._embedded) {
        this.consolidatedSignatures = next._embedded.consolidatedDetails;
      } else {
        this.consolidatedSignatures = [];
      }
      this.page = next.page;
      this.links = next._links;
    }, error => {
      this.destroyAutorefresh();
      this.loading = false;
      this.processError(this.translate.instant('TITLE.CONSOLIDATED-SERVICES'), error);
    });
  }

  public hasRole(name: string): boolean {
    return this.authenticationService.hasRole(name);
  }

  search(): void {
    if (!this.hasNotCorrectDateRange()) {
      this.getTotalByService();
      this.loadConsolidatedServices(Page.First);
    }
  }

  public reloadEnterprises() {
    this.enterprises = LocalStorage.getEnterprisesExtraBy(this.partnerSelected.id);
    this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
    this.workflows = LocalStorage.getWorkflowsExtraBy(this.enterpriseSelected.id);
    this.workflowSelected = this.workflows[Constant.ZERO_INDEX];
    this.queryLevel = this.partnerSelected.id !== Constant.ALL_PARTNER_ID ? QueryLevel.LVL_ONE : QueryLevel.LVL_ZERO;
    this.loadConsolidatedServices(Page.First);
  }

  public reloadWorkflows() {
    this.workflows = LocalStorage.getWorkflowsExtraBy(this.enterpriseSelected.id);
    this.queryLevel = this.enterpriseSelected.id !== Constant.ALL_ENTERPRISE_ID ? QueryLevel.LVL_TWO : QueryLevel.LVL_ONE;
    if (Constant.EMPTY_LIST !== this.workflows.length) {
      this.workflowSelected = this.workflows[Constant.ZERO_INDEX];
      this.loadConsolidatedServices(Page.First);
    }
  }

  onDateSelectionFrom(date: NgbDate) {
    this.hasNotCorrectDateRange();
    if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.fromDate = date;
    }
    const initialDate = new Date(NgbDateStructUtil.toString2YYYYMMdd(this.fromDate));
    const endTime = new Date(NgbDateStructUtil.toString2YYYYMMdd(this.toDate));
    if (this.getDaysDifference(endTime, initialDate) >= this.THREE_MONTHS_ON_DAYS) {
      this.toDate = this.calendar.getNext(date, 'd', this.THREE_MONTHS_ON_DAYS);
    }
  }

  onDateSelectionTo(date: NgbDate) {
    this.hasNotCorrectDateRange();
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else {
      this.toDate = date;
    }
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  public downloadReportOf() {
    let partnerId: number;
    let enterpriseId: number;
    let url: string;
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      partnerId = this.partnerSelected.id;
      enterpriseId = this.enterpriseSelected.id;
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      partnerId = LocalStorage.getPartnerId();
      enterpriseId = this.enterpriseSelected.id;
    } else {
      partnerId = LocalStorage.getPartnerId();
      enterpriseId = LocalStorage.getEnterpriseId();
    }

    url = Constant.ROOT_API_V1.concat('/consolidatedReport/download?',
      'partnerId=', String(partnerId),
      '&enterpriseId=', String(enterpriseId),
      '&workflowId=', String(this.workflowSelected.id),
      '&dateFrom=', NgbDateStructUtil.toString2YYYYMMdd(this.fromDate),
      '&dateTo=', NgbDateStructUtil.toString2YYYYMMdd(this.toDate));
    this.signatureReportService.getReportOf(url).subscribe(next => {
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      control.download = this.translate.instant('TITLE.REPORT-CONSOLIDATED');
      control.click();
      this.loading = false;
    }, error => {
      const title = this.translate.instant('TITLE.DOWNLOAD-REPORT');
      this.processError(title, error);
    });
  }

  private processError(title: string, error: any) {
    const status = error.status;
    this.title = this.translate.instant('TITLE.CONSOLIDATED-SERVICES');
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
      } else {
        Dialog.show(InformType.Danger, title);
      }
    } else {
      Dialog.show(InformType.Danger, title, error.error.message);
    }
  }

  public hasNotCorrectDateRange(): boolean {
    let firstDate = NgbDateStructUtil.toString2YYYYMMdd(this.fromDate);
    let secondDate = NgbDateStructUtil.toString2YYYYMMdd(this.toDate);
    firstDate = firstDate.substring(0, firstDate.length - 1);
    secondDate = secondDate.substring(0, secondDate.length - 1);
    const initialDate = new Date(firstDate);
    const endTime = new Date(secondDate);
    const daysDiff = this.getDaysDifference(initialDate, endTime);
    return daysDiff > 91;
  }

  public getDaysDifference(firstDate: Date, secondDate: Date): number {
    const timeDiff = firstDate.getTime() - secondDate.getTime();
    return Math.ceil(timeDiff / (1000 * 3600 * 24)) * -1;
  }

  public hasMoreThanZero(value: number): boolean {
    return value > 0;
  }

  public hasSelectedAnyPartner(): boolean {
    return this.partnerSelected.id !== Constant.ALL_PARTNER_ID;
  }

  public hasSelectedAnyEnterprise(): boolean {
    return this.enterpriseSelected.id !== Constant.ALL_ENTERPRISE_ID;
  }

  public getVisibilityColumnPartner(): boolean {
    if (this.hasRole(this.ROLE_SUPERADMIN) && this.hasSelectedAnyPartner()) {
      return false;
    } else {
      return !(this.hasRole(this.ROLE_PARTNER) || this.hasRole(this.ROLE_ADMIN));
    }
  }

  public getVisibilityColumnEnterprise(): boolean {
    if (this.hasRole(this.ROLE_SUPERADMIN) && this.hasSelectedAnyPartner() && !this.hasSelectedAnyEnterprise()) {
      return true;
    } else {
      return this.hasRole(this.ROLE_PARTNER) && !this.hasSelectedAnyEnterprise();
    }
  }

  public getVisibilityColumnWorkflow(): boolean {
    if (this.hasRole(this.ROLE_SUPERADMIN) && this.hasSelectedAnyEnterprise()) {
      return true;
    } else if (this.hasRole(this.ROLE_PARTNER) && this.hasSelectedAnyEnterprise()) {
      return true;
    } else {
      return this.hasRole(this.ROLE_ADMIN);
    }
  }

  public viewDetail(consolidatedDetail: Consolidated, serviceIdentifier: number) {
    let partnerIdentifier;
    let enterpriseIdentifier;
    let workflowIdentifier;
    let totalQuantity;
    let description;
    let partnerNames;
    let enterpriseNames;
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      partnerIdentifier = consolidatedDetail.partnerId ? consolidatedDetail.partnerId : this.partnerSelected.id;
      enterpriseIdentifier = consolidatedDetail.enterpriseId ? consolidatedDetail.enterpriseId : this.enterpriseSelected.id;
      partnerNames = consolidatedDetail.partnerName ? consolidatedDetail.partnerName : this.partnerSelected.name;
      enterpriseNames = consolidatedDetail.enterpriseName ? consolidatedDetail.enterpriseName : this.enterpriseSelected.name;
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      partnerIdentifier = LocalStorage.getPartnerId();
      enterpriseIdentifier = consolidatedDetail.enterpriseId ? consolidatedDetail.enterpriseId : this.enterpriseSelected.id;
      partnerNames = consolidatedDetail.partnerName;
      enterpriseNames = consolidatedDetail.enterpriseName ? consolidatedDetail.enterpriseName : this.enterpriseSelected.name;
    } else {
      partnerIdentifier = LocalStorage.getPartnerId();
      enterpriseIdentifier = consolidatedDetail.enterpriseId ? consolidatedDetail.enterpriseId : LocalStorage.getEnterpriseId();
      partnerNames = consolidatedDetail.partnerName;
      enterpriseNames = consolidatedDetail.enterpriseName;
    }

    workflowIdentifier = consolidatedDetail.workflowId ? consolidatedDetail.workflowId : this.workflowSelected.id;

    switch (serviceIdentifier) {
      case Service.ELECTRONIC :
        totalQuantity = consolidatedDetail.quantityGraphicSignature;
        description = this.translate.instant('LABEL.GRAPHIC-SIGNATURES');
        break;
      case Service.DIGITAL :
        totalQuantity = consolidatedDetail.quantityDigitalSignature;
        description = this.translate.instant('LABEL.DIGITAL-SIGNATURES');
        break;
      case Service.CLOUD :
        totalQuantity = consolidatedDetail.quantityOneSignSignature;
        description = this.translate.instant('LABEL.ONE-SIGN-SIGNATURES');
        break;
      case Service.REMOTE :
        totalQuantity = consolidatedDetail.quantityRemoteSignature;
        description = this.translate.instant('LABEL.REMOTE-SIGNATURES');
        break;
      case Service.REMOTE_WITH_TIMESTAMP :
        totalQuantity = consolidatedDetail.quantityRemoteSignatureWithTimeStamp;
        description = this.translate.instant('LABEL.REMOTE-SIGNATURES-WITH-TIMESTAMP');
        break;
      case Service.REMOTE_WITH_LTV :
        totalQuantity = consolidatedDetail.quantityRemoteSignatureWithLTV;
        description = this.translate.instant('LABEL.REMOTE-SIGNATURES-LONGEVA');
        break;
      case Service.TIMESTAMP :
        totalQuantity = consolidatedDetail.quantityTimeStamp;
        description = this.translate.instant('LABEL.TIMESTAMP-SIGNATURES');
        break;
      case Service.SEND_ELECTRONIC_NOTIFICATION :
        totalQuantity = consolidatedDetail.quantitySendElectronicNotification;
        description = this.translate.instant('LABEL.SENDING-OF-NOTIFICATIONS-ELECTRONIC-TO-ADDRESS');
        break;
      case Service.SEND_EMAIL :
        totalQuantity = consolidatedDetail.quantitySendEmail;
        description = this.translate.instant('LABEL.SENDING-OF-NOTIFICATIONS-TO-E-MAIL');
        break;
      case Service.NOTCER :
        totalQuantity = consolidatedDetail.quantityNotcer;
        description = this.translate.instant('LABEL.NOTCER');
        break;
    }

    /**
     * Objeto creado para ser usado en la cabecera y busqueda de la siguiente pantalla detalle
     */
    const headerParameters = {
      partnerId: partnerIdentifier,
      partnerName: partnerNames,
      enterpriseId: enterpriseIdentifier,
      enterpriseName: enterpriseNames,
      workflowId: workflowIdentifier,
      quantity: totalQuantity,
      serviceId: serviceIdentifier,
      serviceName: description,
      fromDate: this.fromDate,
      toDate: this.toDate
    };

    /**
     * Almacena los identificadores seleccionados en los filtros de búsqueda
     */
    const selectedControls = {
      partnerId: this.partnerSelected.id,
      enterpriseId: this.enterpriseSelected.id,
      workflowId: this.workflowSelected.id,
      fromDate: this.fromDate,
      toDate: this.toDate,
      queryLevel: this.queryLevel
    };
    LocalStorage.setItem('headerParameters', headerParameters);
    LocalStorage.setItem('selectedControls', selectedControls);
    this.route.navigate(['signature-report']);
  }

  private getTotalByService() {
    let url;
    let partnerId;
    let enterpriseId;
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      partnerId = this.partnerSelected.id;
      enterpriseId = this.enterpriseSelected.id;
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      partnerId = LocalStorage.getPartnerId();
      enterpriseId = this.enterpriseSelected.id;
    } else {
      partnerId = LocalStorage.getPartnerId();
      enterpriseId = LocalStorage.getEnterpriseId();
    }
    url = Constant.ROOT_API_V1.concat('/generalQuantities?',
      'partnerId=', String(partnerId),
      '&enterpriseId=', String(enterpriseId),
      '&workflowId=', String(this.workflowSelected.id),
      '&dateFrom=', NgbDateStructUtil.toString2YYYYMMdd(this.fromDate),
      '&dateTo=', NgbDateStructUtil.toString2YYYYMMdd(this.toDate),
      '&size=10&sort=id,desc');

    this.signatureReportService.get(url).subscribe((next: any) => {
      if (next.generalQuantities) {
        this.generalQuantities = next.generalQuantities;
      }
    }, error => {
      this.processError(this.translate.instant('TITLE.CONSOLIDATED-SERVICES'), error);
    });
  }

  private beginAutorefreh() {
    this.interval = setInterval(() => {
      if (!this.hasNotCorrectDateRange()) {
        this.getTotalByService();
        if (this.consolidatedSignatures.length !== 0) {
          this.loadConsolidatedServices(Page.Self, 'auto');
        } else {
          this.loadConsolidatedServices(Page.First, 'auto');
        }
      }
    }, 2000);
  }
}
